define.alias("ember-intl/services/intl", "preview-grid/services/intl");